<template>
    <div>
        <div id="PermisosDeUsuarios_div" class="w-100 px-5 py-4">
            <div id="TituloPermisosDeUsuarios_div">
                <h1>PERMISOS DEL USUARIO</h1>
                <h3>Encargado de asignar/editar los permisos del usuario</h3>
            </div>
            <div class="d-flex row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3 padding-div-low">
                    <div class="area">
                        <h2>Búsqueda</h2>
                        <h6>Se puede buscar por medio del login del usuario o por medio de la combinacion del nombre del usuario.<br />La busqueda prioritizara la busqueda por medio de login del usuario</h6>
                        <hr />
                        <h6>Login del usuario</h6>
                        <input type="text" class="form-control" v-model="login" placeholder="ejemplo@pjags.gob.mx" />
                        <hr />
                        <div class="form-group">
                            <h6>Nombre(s)</h6>
                            <input type="text" class="form-control" v-model="nombres" placeholder="Nombre o nombres del usuario" />
                        </div>
                        <div class="form-group">
                            <h6>Primer apellido</h6>
                            <input type="text" class="form-control" v-model="primerApellido" placeholder="Primer apellido del usuario" />
                        </div>
                        <div class="form-group">
                            <h6>Segundo apellido</h6>
                            <input type="text" class="form-control" v-model="segundoApellido" placeholder="Segundo apellido del usuario" />
                        </div>
                        <br />
                        <div id="BuscarUsuario_div" class="text-right">
                            <button class="btn btn-primary overwrapDeBotones" id="buscarUsuario" v-on:click="BuscarUsuarios()">Buscar usuario</button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 padding-div-low">
                    <div class="area">
                        <h3 v-if="usuario.UsuarioId == null">Usuarios</h3>
                        <h6 v-if="usuario.UsuarioId == null">Aqui se muestra el listado de usuarios que se obtuvo en base a sus filtros de busqueda.</h6>
                        <h6 v-if="usuario.UsuarioId == null">Seleccione una de las filas para poder asignarle los permisos al usuario.</h6>
                        <hr v-if="usuario.UsuarioId == null" />
                        <div v-if="usuario.UsuarioId == null" class="col-12 table-responsive">
                            <table class="table table-striped table-light table-hover table-bordered" id="tablaDeUsuarios_table">
                                <thead class="thead-dark text-center">
                                    <tr>
                                        <th>ID</th>
                                        <th>Nombre completo</th>
                                        <th>Login</th>
                                        <th>Activo</th>
                                    </tr>
                                </thead>
                                <tbody class="text-justify">
                                    <tr v-if="respuestaDeListadoDeUsuarios.length <= 0" class="text-center" >
                                        <td colspan="4">No existen registros con esas condiciones de busqueda</td>
                                    </tr>
                                    <tr v-else v-for="usuarioDelListado in respuestaDeListadoDeUsuarios" :key="usuarioDelListado.IdUsuario" v-on:click="AsignaElUsuarioYLogin(usuarioDelListado.IdUsuario, usuarioDelListado.Email)" style="cursor: pointer">
                                        <td class="text-center">{{usuarioDelListado.IdUsuario}}</td>
                                        <td>{{usuarioDelListado.Nombre}}{{(usuarioDelListado.ApellidoPaterno != "" && usuarioDelListado.ApellidoPaterno != null ? " " + usuarioDelListado.ApellidoPaterno : "")}}{{(usuarioDelListado.ApellidoMaterno != "" && usuarioDelListado.ApellidoMaterno != null ? " " + usuarioDelListado.ApellidoMaterno : "")}}</td>
                                        <td>{{usuarioDelListado.Email}}</td>
                                        <td class="text-center">{{(usuarioDelListado.UsuarioActivo == true ? 'Si' : 'No')}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <h4 v-if="usuario.UsuarioId != null">Permisos de los sistemas para {{usuario.Login}}</h4>
                        <h6 v-if="usuario.UsuarioId != null">Seleccione un sistema para poder asignarle los permisos</h6>
                        <hr v-if="usuario.UsuarioId != null" />
                        <div v-if="usuario.UsuarioId != null" class="col-12 col-md-12 text-justify">
                            <div class="form-group">
                                <label for="fechaFinal">Sistema</label>
                                <C031Sistemas v-on:valorParaElPadre="CambioDeSistema" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="parametros_Sistema.Id" :parametros="parametros_Sistema.CondicionesDeBusqueda" :valorDefinido="parametros_Sistema.ValorDefinido"></C031Sistemas>
                            </div>
                            <div id="BotonesDeSistemas_div" class="text-right">
                                <button class="btn btn-danger overwrapDeBotones" id="cancelarAsignacionDePermisos" v-on:click="CancelarLaSeleccionDeSistemas()"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button>
                            </div>
                        </div>
                        <hr v-if="usuario.UsuarioId != null" />
                        <div v-if="permisos.ModulosDelSistema != null && permisos.ModulosDelSistema.length > 0" class="col-12 col-md-12 text-justify">
                            <h3>{{parametros_Sistema.TituloDelSistema}}</h3>
                            <h6>
                                REGLAS PARA LA ASIGNACION DE PERMISOS<br /><br />
                                1.- Si se selecciona un modulo, este actualizara todos las funciones dependientes para que el usuario tenga permiso.<br />
                                2.- Si se selecciona una función, este actualizara para que el modulo sea incluido junto con la funcion seleccionada.<br />
                                3.- Para que los cambios se guarden, cada vez que termine de modificar los permisos de un sistema, debera guardar los cambios antes de cambiar de sistema.
                            </h6>
                            <br />
                            <div class="d-flex row">
                                <div v-for="modulo in permisos.ModulosDelSistema" :key="modulo.ModuloId" class="form-group col-12 moduloPrincipal">
                                    <div class="d-flex row modulos">
                                        <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xlg-10 moduloLeft" v-bind:class="{ 'degradaLaLetraModulo' : (!modulo.TienePermiso) }" v-on:click="AjustaElCambioDePermisosDelModulo(modulo.ModuloId, false)">
                                            <i v-if="modulo.TienePermiso == false" class="far fa-square"></i><i v-else-if="modulo.TienePermiso == true" class="far fa-check-square"></i>&nbsp;&nbsp;{{modulo.Nombre}}
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xlg-2 moduloRight" v-bind:class="{ 'degradaLaLetraModulo' : (!modulo.PuedeEditar || !modulo.TienePermiso) }" v-on:click="AjustaElCambioDePermisosDelModulo(modulo.ModuloId, true)">
                                            <i v-if="modulo.PuedeEditar == false" class="far fa-square"></i><i v-else-if="modulo.PuedeEditar == true" class="far fa-check-square"></i>&nbsp;&nbsp;Puede editar
                                        </div>
                                    </div>
                                    <div class="d-flex row text-left funciones">
                                        <div v-for="funcion in modulo.Funciones" :key="funcion.FuncionId" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-6 funcionGeneral">
                                            <div class="d-flex row funcionLimitante">
                                                <div class="form-group col-12 col-sm-12 col-md-8 col-lg-8 col-xlg-8 funcion" v-bind:class="{ 'degradaLaLetra' : !funcion.TienePermiso }" v-on:click="AjustaElCambioDePermisosDeLaFuncion(modulo.ModuloId, funcion.FuncionId, false)">
                                                    <i v-if="funcion.TienePermiso == false" class="far fa-square"></i><i v-else-if="funcion.TienePermiso == true" class="far fa-check-square"></i>&nbsp;&nbsp;{{funcion.Nombre}}
                                                </div>
                                                <div class="form-group col-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 funcion" v-bind:class="{ 'degradaLaLetra' : (!funcion.PuedeEditar || !funcion.TienePermiso) }" v-on:click="AjustaElCambioDePermisosDeLaFuncion(modulo.ModuloId, funcion.FuncionId, true)">
                                                    <i v-if="funcion.PuedeEditar == false" class="far fa-square"></i><i v-else-if="funcion.PuedeEditar == true" class="far fa-check-square"></i>&nbsp;&nbsp;Puede editar
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div id="BotonesDePermisos_div" class="text-right">
                                <button class="btn btn-danger overwrapDeBotones" id="cancelarAsignacionDePermisos" v-on:click="CancelarLaAsignacionDePermisos()"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button>
                                <button class="btn btn-success overwrapDeBotones" id="guardarAsignacionDePermisos" v-on:click="GuardarPermisosDelUsuario()"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar permisos</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'

export default {
    data() {
        return {
            enumeraciones,
            login: "",
            nombres: "",
            primerApellido: "",
            segundoApellido: "",
            respuestaDeListadoDeUsuarios: [],
            usuario: {
                UsuarioId: null, 
                Login: ""
            },
            parametros_Sistema: {
                Id: 'sistemas_div',
                CondicionesDeBusqueda: {
                    Activo: true, 
                    conPuedeModificarseSusPermisos: true,
                    PuedeModificarseSusPermisos: true
                }, 
                ValorDefinido: -1, 
                TituloDelSistema: ""
            }, 
            permisos: {
                SistemaId: null, 
                ModulosDelSistema: null
            }
        }
    },
    components: {
        C031Sistemas: catalogos.PJ.C031Sistemas
    },
    methods: {
        LimpiaParaNuevaBusqueda: function() {
            this.respuestaDeListadoDeUsuarios = [];

            this.LimpiaParaNuevoUsuario();
        },
        LimpiaParaNuevoUsuario: function() {
            this.usuario = {
                UsuarioId: null, 
                Login: ""
            };

            this.LimpiaParaNuevaSeleccionDeSistema();
        },
        LimpiaParaNuevaSeleccionDeSistema: function() {
            this.parametros_Sistema = {
                Id: 'sistemas_div',
                CondicionesDeBusqueda: {
                    Activo: true,
                    conPuedeModificarseSusPermisos: true,
                    PuedeModificarseSusPermisos: true
                }, 
                ValorDefinido: -1, 
                TituloDelSistema: "",
                SistemaIdSeleccionado: null
            };

            this.permisos = {
                SistemaId: null, 
                ModulosDelSistema: null
            };
            $("#" + this.parametros_Sistema.Id).val("-1");
            $("#" + this.parametros_Sistema.Id).prop("disabled", false);
        },
        VerificaQueElUsuarioEsteIngresado: function () {
            let sinLogin = true;
            let sinNombreCompleto = true;

            if (this.login !== "" && this.login !== null) {
                sinLogin = false;
            }

            if (this.nombres !== "" && this.nombres !== null) {
                sinNombreCompleto = false;
            }

            if (this.primerApellido !== "" && this.primerApellido !== null) {
                sinNombreCompleto = false;
            }

            if (this.segundoApellido !== "" && this.segundoApellido !== null) {
                sinNombreCompleto = false;
            }

            if (sinLogin == true && sinNombreCompleto == true) {
                comun.mensajeDeAlerta("No se ha ingresado el login, nombre, primer o segundo apellido del usuario para poder hacer la busqueda.", null, null);
                return false
            }

            return true;
        },
        BuscarUsuarios: function() {
            this.LimpiaParaNuevaBusqueda();
            if(this.VerificaQueElUsuarioEsteIngresado()) {
                comun.SeEstaCargandoInformacion(true);

                const parametros = {
                    Login: this.login,
                    Nombres: this.nombres,
                    PrimerApellido: this.primerApellido,
                    SegundoApellido: this.segundoApellido,
                    EsPrueba: this.enumeraciones.EsPrueba
                };

                axios.post(
                    api.conexion + api.SICUS.sistema.usuarios.permisosDelUsuario.ObtenUsuarios,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    } else {
                        this.respuestaDeListadoDeUsuarios = respuesta.data.Usuarios;
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
            }
        }, 
        AsignaElUsuarioYLogin: function(usuarioId, login) {
            this.usuario = {
                UsuarioId: usuarioId, 
                Login: login
            }
        },
        VerificaLaInformacionDePermisos: function(datos) {
            if (this.usuario.UsuarioId == null) {
                comun.mensajeDeAlerta("No existe un usuario del cual se pueda buscar los permisos.<br />Realice la busqueda de nuevo.", null, null);
                return false;
            }

            if (parseInt(datos.target.value) <= 0) {
                return false
            }

            return true;
        },
        CambioDeSistema: function(datos) {
            this.permisos = {
                SistemaId: null, 
                ModulosDelSistema: null
            };
            this.parametros_Sistema.TituloDelSistema = null;

            if (this.VerificaLaInformacionDePermisos(datos)) {
                comun.SeEstaCargandoInformacion(true);
                this.parametros_Sistema.TituloDelSistema = datos.target.options[datos.target.selectedIndex].text;

                const parametros = {
                    UsuarioId: this.usuario.UsuarioId,
                    SistemaId: parseInt(datos.target.value),
                    EsPrueba: this.enumeraciones.EsPrueba
                };

                axios.post(
                    api.conexion + api.SICUS.sistema.usuarios.permisosDelUsuario.ObtenLosPermisosDelUsuarioYSistema,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        this.LimpiaParaNuevaSeleccionDeSistema();
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    } else {
                        $("#" + this.parametros_Sistema.Id).prop("disabled", true);
                        this.permisos = {
                            SistemaId: parseInt(datos.target.value), 
                            ModulosDelSistema: respuesta.data.ModulosDelSistema
                        };
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
            }
        },
        CancelarLaSeleccionDeSistemas: function() {
            this.LimpiaParaNuevoUsuario();
        },
        CancelarLaAsignacionDePermisos: function() {
            this.LimpiaParaNuevaSeleccionDeSistema();
        }, 
        AjustaElCambioDePermisosDelModulo: function(moduloId, puedeEditar = false) {
            this.permisos.ModulosDelSistema.forEach(modulo => {
                if (modulo.ModuloId == moduloId) {
                    if (puedeEditar == true)
                        modulo.TienePermiso = true;
                    else
                        modulo.TienePermiso = !puedeEditar ? !modulo.TienePermiso : modulo.TienePermiso;

                    if (modulo.TienePermiso == false)
                        modulo.PuedeEditar = false;
                    else 
                        modulo.PuedeEditar = puedeEditar ? !modulo.PuedeEditar : modulo.PuedeEditar;

                    if (modulo.Funciones.length > 0)
                        modulo.Funciones.forEach(funcion => {
                            funcion.TienePermiso = modulo.TienePermiso;
                            funcion.PuedeEditar = modulo.PuedeEditar;
                        })
                }
            });
        }, 
        AjustaElCambioDePermisosDeLaFuncion: function(moduloId, funcionId, puedeEditar = false) {
            let desactivarModulo = true;
            let desactivarPuedeEditarModulo = true;

            this.permisos.ModulosDelSistema.forEach(modulo => {
                if (modulo.ModuloId == moduloId) {
                    modulo.Funciones.forEach(funcion => {
                        if (funcion.FuncionId == funcionId) {
                            if (puedeEditar == true)
                                funcion.TienePermiso = true;
                            else
                                funcion.TienePermiso = !puedeEditar ? !funcion.TienePermiso : funcion.TienePermiso;

                            if(funcion.TienePermiso == false)
                                funcion.PuedeEditar = false;
                            else
                                funcion.PuedeEditar = puedeEditar ? !funcion.PuedeEditar : funcion.PuedeEditar;
                        }

                        if(funcion.TienePermiso == true)
                            desactivarModulo = false
                    })

                    if (desactivarModulo)
                        modulo.TienePermiso = false;
                    else 
                        modulo.TienePermiso = true;

                    if (modulo.Funciones.filter(cond => cond.PuedeEditar == false).length > 0)
                        modulo.PuedeEditar = false;
                    else 
                        modulo.PuedeEditar = true;
                }
            });
        }, 
        VerificaQueLosPermisosExistan: function() {
            if (this.permisos.SistemaId == null) {
                comun.mensajeDeAlerta("No existe el sistema el cual fue seleccionado para los permisos.<br />Actualice la pagina para recargar la información.", null, null);
                return false
            }

            if (this.permisos.ModulosDelSistema == null || this.permisos.ModulosDelSistema.length <= 0) {
                comun.mensajeDeAlerta("No existe los permisos del sistema del cual fue seleccionado.<br />Actualice la pagina para recargar la información.", null, null);
                return false
            }

            if (this.usuario.UsuarioId == null) {
                comun.mensajeDeAlerta("No existe la información del usuario que fue seleccionado<br />Actualice la pagina para recargar la información.", null, null);
                return false
            }

            return true;
        },
        GuardarPermisosDelUsuario: function() {
            if(this.VerificaQueLosPermisosExistan()) {
                comun.SeEstaCargandoInformacion(true);

                const parametros = {
                    SistemaId: this.permisos.SistemaId, 
                    Permisos: this.CreaLosPermisos(), 
                    UsuarioId: this.usuario.UsuarioId, 
                    EsPrueba: this.enumeraciones.EsPrueba
                }
                
                axios.post(
                    api.conexion + api.SICUS.sistema.usuarios.permisosDelUsuario.GuardarPermisosDelUsuario,
                    parametros,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                    if(respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                    } else {
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        this.LimpiaParaNuevaSeleccionDeSistema();
                    }
                    comun.SeEstaCargandoInformacion(false);
                }
                ).catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                });
            }
        }, 
        CreaLosPermisos: function() {
            let permisos = [];

            this.permisos.ModulosDelSistema.forEach(modulo => {
                const condicionesDeSoloElModulo = {
                    todosTienenPermiso: true, 
                    todosSonElMismoPuedeEditar: true, 
                    puedeEditar: null
                }

                if(modulo.TienePermiso == true) {
                    if (modulo.Funciones && modulo.Funciones.length > 0) {
                        modulo.Funciones.forEach(funcion => {
                            if(funcion.TienePermiso == false)
                                condicionesDeSoloElModulo.todosTienenPermiso = false
                            
                            if(condicionesDeSoloElModulo.puedeEditar == null)
                                condicionesDeSoloElModulo.puedeEditar = funcion.PuedeEditar
                            else if (condicionesDeSoloElModulo.puedeEditar != funcion.PuedeEditar) {
                                condicionesDeSoloElModulo.todosSonElMismoPuedeEditar = false;
                            }
                        })
                    } else {
                        condicionesDeSoloElModulo.puedeEditar = modulo.PuedeEditar;
                    }

                    if(condicionesDeSoloElModulo.todosTienenPermiso && condicionesDeSoloElModulo.todosSonElMismoPuedeEditar) {
                        permisos.push({
                            PuedeEditar: condicionesDeSoloElModulo.puedeEditar, 
                            UsuarioId: this.usuario.UsuarioId, 
                            Modulo: modulo, 
                            Funcion: null
                        })
                    } else {
                        if (modulo.Funciones && modulo.Funciones.length > 0) {
                            modulo.Funciones.forEach(funcion => {
                                if(funcion.TienePermiso === true)
                                    permisos.push({
                                        PuedeEditar: funcion.PuedeEditar, 
                                        UsuarioId: this.usuario.UsuarioId, 
                                        Modulo: modulo, 
                                        Funcion: funcion
                                    })
                            })
                        }
                    }
                }
            })

            return permisos;
        }
    }
}
</script>

<style scoped>
    .moduloPrincipal {
        padding-left: 0;
        padding-right: 0;
    }

    .modulos {
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;
        padding-bottom: 0;
        margin-left: 0;
        margin-right: 0;
        border: 1px #504f54 solid;
        background-color: #504f54;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        text-transform: uppercase;
    }

        .modulos:hover {
            background-color: #7a7880;
            cursor: pointer;
        }

    .moduloLeft {
        padding-top: 10px;
        padding-bottom: 10px;
        margin: 0;
        border-top-left-radius: 5px;
    }

        .moduloLeft:hover {
            background-color: #606060;
            color: whitesmoke;
            cursor: pointer;
        }

    .moduloRight {
        padding-top: 10px;
        padding-bottom: 10px;
        margin: 0;
        border-top-right-radius: 5px;
    }

        .moduloRight:hover {
            background-color: #606060;
            color: whitesmoke;
            cursor: pointer;
        }

    .funciones {
        border: 1px #504f54 solid;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 5px;
        padding-bottom: 5px;
        margin-left: 0;
        margin-right: 0;
    }

    .funcionGeneral {
        padding-left: 7px;
        padding-right: 7px;
        padding-top: 5px;
        padding-bottom: 5px;
        margin: 0;
        border: 1px solid #4c4b50;
    }

        .funcionGeneral:hover {
            background-color: #4c4b50;
            cursor: pointer;
        }

    .funcionLimitante {
        margin-left: 0;
        margin-right: 0;
    }

    .funcion {
        padding-left: 7px;
        padding-right: 7px;
        padding-top: 5px;
        padding-bottom: 5px;
        margin: 0;
    }

        .funcion:hover {
            background-color: #7b7b7b;
            cursor: pointer;
        }
    
    .degradaLaLetra {
        color: #6c6c6c;
    }

        .degradaLaLetra:hover {
            color: #303030
        }

    .degradaLaLetraModulo {
        color: #232323;
    }

        .degradaLaLetraModulo:hover {
            color: #cbcbcb
        }
</style>


// WEBPACK FOOTER //
// src/components/SICUS/Usuarios/PermisosDeUsuarios/Index.vue